import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const PERIOD_OPTIONS = [
  { value: 'week', label: 'WEEKLY' },
  { value: 'month', label: 'MONTHLY' },
  { value: 'quarter', label: 'QUARTERLY' },
  { value: 'year', label: 'YEARLY' },
];

export const PERIOD_NOUN = { week: 'week', month: 'month', quarter: 'quarter', year: 'year' };

/**
 * Period toggle (week/month/quarter/year) with previous/next navigation.
 * `offset` counts backwards from the current period (0 = current).
 */
const PeriodSelector = ({ period, onPeriodChange, offset, onOffsetChange, label, caption, testIdPrefix = 'period' }) => (
  <Card className="border-border">
    <CardContent className="p-4 space-y-3">
      <div className="grid grid-cols-4 gap-1 bg-muted p-1" role="tablist" aria-label="Summary period">
        {PERIOD_OPTIONS.map(option => (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={period === option.value}
            onClick={() => {
              onPeriodChange(option.value);
              onOffsetChange(0);
            }}
            className={`py-1.5 text-[10px] sm:text-xs font-medium tracking-wider transition-colors ${
              period === option.value ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
            data-testid={`${testIdPrefix}-${option.value}`}
          >
            {option.label}
          </button>
        ))}
      </div>
      <div className="flex items-center justify-between">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onOffsetChange(offset + 1)}
          aria-label={`Previous ${PERIOD_NOUN[period]}`}
          data-testid={`${testIdPrefix}-prev-btn`}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <div className="text-center min-w-0">
          <p className="text-sm text-muted-foreground uppercase tracking-wider">{caption}</p>
          <p className="text-base sm:text-lg font-bold">{label}</p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onOffsetChange(Math.max(0, offset - 1))}
          disabled={offset === 0}
          aria-label={`Next ${PERIOD_NOUN[period]}`}
          data-testid={`${testIdPrefix}-next-btn`}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </CardContent>
  </Card>
);

export default PeriodSelector;
